import { registerAction } from '../../Action'

const LOAD_MOMENT = 'LOAD_MOMENT'

const updateMoment = (moments, moment) => {
  const momentIndex = moments.findIndex(
    (thisMoment) => thisMoment.id === moment.id
  )
  return moments.splice(momentIndex, 1, moment)
}

const reducer = (state = {}, action) => ({
  ...state,
  moments: updateMoment(state.moments, action.payload),
})

const loadMoment = registerAction(LOAD_MOMENT, { reducer })

export default loadMoment
